import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home.component/home.component';
import { AboutJccComponent } from './pages/about-jcc.component/about-jcc.component';
import { ContactComponent } from './pages/contact.component/contact.component';
import { DownloadComponent } from './pages/download.component/download.component';
import { SupportComponent } from './pages/support.component/support.component';
import { PrivacyComponent } from './pages/privacy.component/privacy.component';
import { TermsComponent } from './pages/terms.component/terms.component';
import { CookiesComponent } from './pages/cookies.component/cookies.component';
import { VerifyEmailComponent } from './pages/verify-email.component/verify-email.component';
import { ResetPasswordComponent } from './pages/reset-password.component/reset-password.component';
import { LoginComponent } from './pages/login.component/login.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'about-jcc',
        component: AboutJccComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'download',
        component: DownloadComponent
    },
    {
        path: 'support',
        component: SupportComponent
    },
    {
        path: 'privacy',
        component: PrivacyComponent
    },
    {
        path: 'terms',
        component: TermsComponent
    },
    {
        path: 'cookies',
        component: CookiesComponent
    },
    {
        path: 'verify-email',
        component: VerifyEmailComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        // Admin console — lazy-loaded so the marketing bundle stays small.
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
    },
    {
        // Public share landing pages (deep-link targets for the mobile app).
        path: 'r/:id',
        loadComponent: () =>
            import('./pages/restroom-share.component/restroom-share.component').then(m => m.RestroomShareComponent)
    },
    {
        path: 'u/:shareCode',
        loadComponent: () =>
            import('./pages/profile-share.component/profile-share.component').then(m => m.ProfileShareComponent)
    },
    {
        path: 'play/:code',
        loadComponent: () =>
            import('./pages/play-invite.component/play-invite.component').then(m => m.PlayInviteComponent)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];
